/**
 * Sign in. An asymmetric two-zone composition rather than a card in the middle of a page: brand
 * on the left, the form on the right, the split itself doing the structural work.
 *
 * The authenticated app is dense and operational. This screen is the opposite on purpose — one
 * focal point, one primary action, more breathing room — while holding the same typography,
 * palette, radii and component language, so it reads as the same product at a calmer moment.
 */

import { readHint } from '@pos/shared';

import { AuthLayout, PasswordLoginForm } from '@/features/auth';

export function SignInPage() {
  const hint = readHint();

  return (
    <AuthLayout title="Welcome back" description="Sign in to carry on.">
      <PasswordLoginForm username={hint?.username ?? ''} />
    </AuthLayout>
  );
}
